import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription, map } from 'rxjs';
import { Breadcrumb } from './breadcrumb';
import { BreadcrumbsService } from './breadcrumbs.service';

@UntilDestroy()
@Component({
  selector: 'fz-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class BreadcrumbsComponent implements OnInit {
  @Input()
  sticky = false;

  @Input()
  enableHome = false;

  crumbs!: Breadcrumb[];

  protected subscription?: Subscription;

  constructor(
    protected service: BreadcrumbsService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  @ViewChild('widgetsContent', { read: ElementRef })
  widgetsContent: ElementRef<HTMLDivElement>;

  public ngOnInit(): void {
    this.service.crumbs$
      .pipe(
        map((crumbs) => {
          return [
            // add home crumb in case it's enabled
            ...(this.enableHome
              ? [
                  {
                    ignore: false,
                    key: 'home',
                    label: 'Home',
                    href: '/?sh=true',
                  } as Breadcrumb,
                ]
              : []),
            ...crumbs,
          ];
        }),
        untilDestroyed(this),
      )
      .subscribe((crumbs) => {
        console.log('[ BreadcrumbsComponent/Subscription ]', crumbs);
        this.crumbs = crumbs as Breadcrumb[];
        // wait 800 before scrolling to the right
        setTimeout(() => this.scrollRight(), 800);

        // mark for check
        this.changeDetectorRef.markForCheck();
      });
  }

  public scrollRight(): void {
    if (this.widgetsContent && this.widgetsContent.nativeElement) {
      this.widgetsContent.nativeElement.scrollTo({
        left:
          this.widgetsContent.nativeElement.scrollLeft +
          this.widgetsContent.nativeElement.clientWidth,
        behavior: 'smooth',
      });
    }
  }
}
